// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    
}

.popup-content {
    background-color: #fff;
   
    border-radius: 5px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    width: 50%;
    height:400px;
}

.popup-header{
    height:50px;
    background-color: #6ec581;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.popup-header p{
    font-size: 15px;
    color:#ffffff;
    font-family: 'Poppins',sans-serif;
    font-weight: 600;
    letter-spacing: 1px;
    margin-left: 50px;
}

.close {
    color: #fff;
    float: right;
    font-size: 25px;
    font-weight: bold;
    cursor: pointer;
    margin-top: 15px;
    margin-right: 20px;
}

.close:hover {
    color: black;
}
.cart-items{
    display: flex;
    flex-direction: row;
    margin:30px;
}


.cart-items img{
    width:40%;
}

.cart-items h5{
    text-align: left;
}


.cart-product-details{
    margin-left: 20px;
}

.cart-product-details p{
    font-family: 'Philosopher',serif;
    color:rgba(0, 0, 0, 0.9);
    font-weight: 700;
    font-size: 15px;
    text-align: left;
}

.cart-product-details h5 {
    font-family: 'Poppins', sans-serif;
    color: #666666;
    font-size: 13px;
    letter-spacing: 1px;
    font-weight: 400;
    text-align: left;
    margin-bottom: 10px;
}

.cart-button{
    width:150px
}

.buy-button{
    width:150px;
    font-family: 'Philosopher',serif;
    font-size:18px;
}

@media screen and (max-width:768px){
    .popup {
            display: flex;
            justify-content: center;
            align-items: flex-start;
            position: fixed;
            z-index: 2;
            left: 0;
            top: 180px;
            width: 100%;
            height: fit-content;
            
            
        }
    .popup .popup-content {
            background-color: #fff;
            border-radius: 5px;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
            width: 90%;
            height: fit-content;
            
            
        }
        .cart-items {
            display: flex;
            flex-direction: column;
            margin: 30px;
        }
        .cart-button {
            width: 150px;
            margin-bottom:0px;
        }

        .cart-items img {
            width: 90%;
        }

}`, "",{"version":3,"sources":["webpack://./src/Styles/cartPopup.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,UAAU;IACV,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;;AAEhB;;AAEA;IACI,sBAAsB;;IAEtB,kBAAkB;IAClB,yCAAyC;IACzC,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,iCAAiC;IACjC,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;;AAGA;IACI,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;;AAGA;IACI,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;IAChC,wBAAwB;IACxB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI;YACQ,aAAa;YACb,uBAAuB;YACvB,uBAAuB;YACvB,eAAe;YACf,UAAU;YACV,OAAO;YACP,UAAU;YACV,WAAW;YACX,mBAAmB;;;QAGvB;IACJ;YACQ,sBAAsB;YACtB,kBAAkB;YAClB,yCAAyC;YACzC,UAAU;YACV,mBAAmB;;;QAGvB;QACA;YACI,aAAa;YACb,sBAAsB;YACtB,YAAY;QAChB;QACA;YACI,YAAY;YACZ,iBAAiB;QACrB;;QAEA;YACI,UAAU;QACd;;AAER","sourcesContent":[".popup {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: fixed;\n    z-index: 1;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    \n}\n\n.popup-content {\n    background-color: #fff;\n   \n    border-radius: 5px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\n    width: 50%;\n    height:400px;\n}\n\n.popup-header{\n    height:50px;\n    background-color: #6ec581;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.popup-header p{\n    font-size: 15px;\n    color:#ffffff;\n    font-family: 'Poppins',sans-serif;\n    font-weight: 600;\n    letter-spacing: 1px;\n    margin-left: 50px;\n}\n\n.close {\n    color: #fff;\n    float: right;\n    font-size: 25px;\n    font-weight: bold;\n    cursor: pointer;\n    margin-top: 15px;\n    margin-right: 20px;\n}\n\n.close:hover {\n    color: black;\n}\n.cart-items{\n    display: flex;\n    flex-direction: row;\n    margin:30px;\n}\n\n\n.cart-items img{\n    width:40%;\n}\n\n.cart-items h5{\n    text-align: left;\n}\n\n\n.cart-product-details{\n    margin-left: 20px;\n}\n\n.cart-product-details p{\n    font-family: 'Philosopher',serif;\n    color:rgba(0, 0, 0, 0.9);\n    font-weight: 700;\n    font-size: 15px;\n    text-align: left;\n}\n\n.cart-product-details h5 {\n    font-family: 'Poppins', sans-serif;\n    color: #666666;\n    font-size: 13px;\n    letter-spacing: 1px;\n    font-weight: 400;\n    text-align: left;\n    margin-bottom: 10px;\n}\n\n.cart-button{\n    width:150px\n}\n\n.buy-button{\n    width:150px;\n    font-family: 'Philosopher',serif;\n    font-size:18px;\n}\n\n@media screen and (max-width:768px){\n    .popup {\n            display: flex;\n            justify-content: center;\n            align-items: flex-start;\n            position: fixed;\n            z-index: 2;\n            left: 0;\n            top: 180px;\n            width: 100%;\n            height: fit-content;\n            \n            \n        }\n    .popup .popup-content {\n            background-color: #fff;\n            border-radius: 5px;\n            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\n            width: 90%;\n            height: fit-content;\n            \n            \n        }\n        .cart-items {\n            display: flex;\n            flex-direction: column;\n            margin: 30px;\n        }\n        .cart-button {\n            width: 150px;\n            margin-bottom:0px;\n        }\n\n        .cart-items img {\n            width: 90%;\n        }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
